import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Navbar from './home/Navbar';
import Hero from './home/Hero';
import Ticker from './home/Ticker';
import Bento from './home/Bento';
import Solutions from './home/Solutions';
import Pricing from './home/Pricing';
import Features from './home/Features';
import Footer from './home/Footer';

export default function Home() {
    const { isDarkMode } = useTheme();

    return (
        <div className={`min-h-screen ${isDarkMode ? 'bg-zinc-950 text-zinc-300' : 'bg-white text-zinc-900'} overflow-x-hidden transition-colors duration-300`}>
            <Navbar />
            <Hero />
            <Ticker />
            <Bento />
            <Solutions />
            <Pricing />
            <Features />
            <Footer />
        </div>
    );
}
